var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUserAdd = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7 20.967L27.175 24.1C28.0616 24.8674 28.7727 25.8166 29.2601 26.8831C29.7476 27.9496 29.9999 29.1084 30 30.281V42H8V30.251C7.9998 29.0875 8.24786 27.9373 8.7276 26.8773C9.20735 25.8172 9.90774 24.8718 10.782 24.104L10.873 24.033L15.3 20.964C14.2931 20.3461 13.4612 19.4806 12.8836 18.4501C12.3059 17.4196 12.0017 16.2584 12 15.077V12.923C12.0019 11.0875 12.7318 9.32766 14.0297 8.02975C15.3277 6.73183 17.0875 6.00185 18.923 6H19.077C20.9125 6.00185 22.6723 6.73183 23.9703 8.02975C25.2682 9.32766 25.9981 11.0875 26 12.923V15.077C25.9989 16.2589 25.695 17.4208 25.1173 18.4519C24.5396 19.483 23.7074 20.3489 22.7 20.967ZM14 12.923V15.077C14.0013 16.3823 14.5204 17.6337 15.4434 18.5566C16.3663 19.4796 17.6177 19.9987 18.923 20H19.077C20.3823 19.9987 21.6337 19.4796 22.5566 18.5566C23.4796 17.6337 23.9987 16.3823 24 15.077V12.923C23.9987 11.6177 23.4796 10.3663 22.5566 9.44338C21.6337 8.52042 20.3823 8.00132 19.077 8H18.923C17.6177 8.00132 16.3663 8.52042 15.4434 9.44338C14.5204 10.3663 14.0013 11.6177 14 12.923ZM10 40H28V30.281C27.9999 29.4028 27.8125 28.5346 27.4504 27.7345C27.0883 26.9344 26.5597 26.2207 25.9 25.641L20.686 22H17.312L12.061 25.643C11.4124 26.2227 10.8936 26.9328 10.5384 27.7269C10.1832 28.521 9.99976 29.3811 10 30.251V40ZM34 6H36V11H41V13H36V18H34V13H29V11H34V6Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUserAdd);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/User_Add.cedc9a85811c20aaaa5f5c261e8417b4.svg";